import React, { useEffect, useState } from "react";
import {
  List,
  Card,
  Input,
  Space,
  message,
  Button,
  Row,
  Col,
  Tag,
  Typography,
  Form,
  Select,
} from "antd";
import Axios from "axios";
import { apiRoutes, environment } from "../../auth/apiRoute";
import { CloseOutlined, CloseCircleTwoTone } from "@ant-design/icons";

const { Search } = Input;
const { Text, Title } = Typography;
const gutterLayout = { xs: 8, sm: 16, md: 24, lg: 32 };
Array.prototype.unique = function () {
  var a = this.concat();
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) a.splice(j--, 1);
    }
  }

  return a;
};
export default function ProfileHotel(props) {
  const [loading, setLoading] = useState(false);
  const [myHotelsData, setMyHotelsData] = useState([]);
  const [selectedHotels, setSelectedHotels] = useState([]);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [form] = Form.useForm();
  useEffect(() => {
    getHotelsData();
  }, []);
  useEffect(() => {
    getMyHotels();
  }, [data]);

  const getHotelsData = async () => {
    setLoading(true);
    try {
      const response = await Axios.post(apiRoutes[environment].hotels);

      if (response.status == 200) {
        setData(response.data);
        setFilteredData(response.data);

        console.log(response.data.slice(0, 5));
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const getMyHotels = async () => {
    const myHotels = data.filter((item) => {
      if (item.admin) {
        return item.admin._id == props.user.id;
      }
    });

    setMyHotelsData(myHotels);
    const myHotelsIds = myHotels.map((item) => item._id);
    setSelectedHotels(myHotelsIds);
    form.setFieldsValue({
      hotels: myHotelsIds,
    });
    // console.log(myHotelsIds);
  };

  const onFinish = (values) => {
    console.log(values);
    onConfirm();
  };
  const onChange = (e) => {
    const value = e.target.value.toLowerCase();
    console.log(value);
    if (!value) {
      setFilteredData(data);
    } else if (value.length > 4) {
      var filters = data.filter((item) => {
        return item.name.toLowerCase().includes(value);
      });
      console.log(filters);
      setFilteredData([...filters]);
    }
  };
  const onDeselectHotel = (e) => {
    console.log(selectedHotels);

    setSelectedHotels([...selectedHotels.filter((hotel) => hotel != e)]);
    console.log(selectedHotels);
  };
  const onSelectHotel = (e) => {
    var hotelId = e;
    var hotel = data.find((item) => item._id == hotelId);

    if (hotel.suspended) {
      console.log("hotel is suspended");
      return;
    }

    if (hotel.admin && hotel.admin._id != props.user.id) {
      console.log("hotel is already claimed");
      return;
    }

    var newHotels = selectedHotels;
    if (newHotels.includes(hotelId)) {
      newHotels = newHotels.filter(function (item) {
        return item !== hotelId;
      });
    } else if (selectedHotels.length >= 3) {
      return;
    } else {
      newHotels.push(e);
    }

    setSelectedHotels([...newHotels]);
    console.log(selectedHotels);
  };
  const onConfirm = async () => {
    if (selectedHotels.length == 0) {
      message.info(
        "You have to select at least one hotel to start nominations."
      );
    }

    setLoading(true);
    try {
      const response = await Axios.post(apiRoutes[environment].hotelAdmin, {
        hotels: selectedHotels,
        user: props.user,
      });
      message.success({
        content: "Success, your hotel is updated! ",
        className: "messageBox",
      });
      var myNewHotelsData = myHotelsData.filter((item) => {
        return selectedHotels.includes(item._id);
      });
      setMyHotelsData([...myNewHotelsData]);
      setLoading(false);
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };
  const updateUserHotels = async (values) => {
    setLoading(true);
    try {
      const response = await Axios.post(
        apiRoutes[environment].hotelAdmin,
        values
      );
      message.success({
        content: "Success! Your hotel is updated! ",
        className: "messageBox",
      });
      setLoading(false);
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };
  const HotelList = () => {
    return (
      <List
        size="small"
        header={<div>My Hotels</div>}
        bordered
        dataSource={myHotelsData}
        renderItem={(item) => <List.Item>{item.name}</List.Item>}
      />
    );
  };
  return (
    <div style={{ width: "100%" }}>
      <Title level={4}>Select Hotels</Title>
      <Text>
        Please select at least one hotel to start nominations. You can select up
        to 3 hotels.
      </Text>
      <HotelList />

      <Space />
      <Form onFinish={onFinish} layout={"vertical"} form={form}>
        <Row gutter={gutterLayout}>
          <Col span={24} key={"hotels"}>
            <Form.Item
              name="hotels"
              label={"Select Hotels_ " + selectedHotels.length}
            >
              <Select
                size={"large"}
                mode="multiple"
                showSearch
                tokenSeparators={[","]}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.title ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onDeselect={onDeselectHotel}
                onSelect={onSelectHotel}
                // disabled={selectedHotels.length >= 3}
                options={data.map((item) => {
                  var label = item.name;
                  if (item.suspended) {
                    label = (
                      <div>
                        <Text delete>{item.name}</Text>
                        <Text type="danger"> (Suspended)</Text>
                      </div>
                    );
                  }

                  if (item.admin && item.admin._id != props.user.id) {
                    label = (
                      <div>
                        <Text delete>{item.name}</Text>
                        <Text type="danger">
                          {" "}
                          (Claimed by {item.admin.firstName})
                        </Text>
                      </div>
                    );
                  }

                  return {
                    value: item._id,
                    title: item.name,
                    label: label,
                    key: item._id,
                    disabled:
                      item.suspended ||
                      (item.admin && item.admin._id != props.user.id) ||
                      (selectedHotels.length >= 3 &&
                        !selectedHotels.includes(item._id)),
                  };
                })}
              />
            </Form.Item>
          </Col>

          <Col span={24} key={"confirm"}>
            <Form.Item>
              <Button htmlType="submit">Confirm</Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}
